import styles from './DeliveryList.module.css'
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import TableItem from "../../FormTemplate/TableItem/TableItem";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import {ReduxStateInt} from "../../Reducer/GlobalReducer";
import SelectUnit, {SelectUnitDataInt, SelectUnitRefInt} from "../../FormTemplate/SelectUnit/SelectUnit";
import InputItem, {IRefInputItem} from "../../FormTemplate/InputItem/InputItem";

interface ISimItem
{
    [ley:string]:any
    ctn:string
    chatId:string
    userId:string
    group: string
    amount: number
}

export default function DeliveryList()
{

    const refMonth = useRef<SelectUnitRefInt>(null)
    const refYear = useRef<IRefInputItem>(null)

    const [monthList, setMonthList] = useState<SelectUnitDataInt[]>([
        {
            name: "январь",
            val:  "январь"
        },
        {
            name: "февраль",
            val:  "февраль"
        },
        {
            name: "март",
            val:  "март"
        },
        {
            name: "апрель",
            val:  "апрель"
        },
        {
            name: "май",
            val:  "май"
        },
        {
            name: "июнь",
            val:  "июнь"
        },
        {
            name: "июль",
            val:  "июль"
        },
        {
            name: "август",
            val:  "август"
        },
        {
            name: "сентябрь",
            val:  "сентябрь"
        },
        {
            name: "октябрь",
            val:  "октябрь"
        },
        {
            name: "ноябрь",
            val:  "ноябрь"
        },
        {
            name: "декабрь",
            val:  "декабрь"
        },
        {
            name: "январь",
            val:  1
        },
    ])

    const [month, setMonth] = useState<string>()
    const [year, setYear] = useState<number>((new Date()).getFullYear())

    const listData = useRef(null)
    const [ldrList,rsList,exList] = useApiQuery("/surkov/list","get",listData);
    const [simList , setSimList] = useState<ISimItem[]>([])
    const refState = useRef<ErrorLineItemRef>(null)

    const [work, setWork] = useState(false)
    const [workName, setWorkName] = useState("")
    const baseUrl = useSelector((state: ReduxStateInt) => {
        return state.baseUrl
    })
    const [fileSelected, setFileSelected] = useState(false)

    const data = useRef(new FormData())
    const [ldrXlsFile,rsXlsFile,exXlsFile] = useApiQuery("/excel/upload","file",data);


    const uploadData = useRef<{
        filePath:string
        month:string
        year:string
    }>(null)
    const [ldrUpload,rsUpload,exUpload] = useApiQuery("/surkov/upload","post",uploadData);


    useEffect(()=>{
            loadList()
    },[listData])


    const loadList = ()=>{
        exList().then((e)=>{
            if(e?.success)
            {
                setSimList(e?.payload)
                return
            }


        })
    }

    async function uploadFile(){
        return exXlsFile().then((e)=>{
            if(e?.success) return e?.payload
            return null
        })
    }


    const handleFile = (e:React.ChangeEvent<HTMLInputElement>) =>{
        data.current.delete("file")
        if(! e.target.files)
        {
            setFileSelected(false)
            return
        }
        if(e.target.files.length > 0 )setFileSelected(true)
        else setFileSelected(false)
        data.current.append("file",e.target.files[0])
    }


    async function handleUpload (){
        if(!refYear.current) return
        if(!refMonth.current) return
        if(!refYear.current.validate())
        {
            if(refState.current)refState.current.show("Не корректен год", true, 3000)
            return
        }
        if(!month || month.length === 0)
        {
            if(refState.current)refState.current.show("Не выбран период", true, 3000)
            return
        }
        setWork(true)
        try {
            const file = await uploadFile()
            loadList()
            console.log(file)
            uploadData.current ={
                filePath: file,
                year: year.toString(),
                month: month

            }
            exUpload().then((e)=>{
                if(e?.success)
                {
                    if(refState.current)refState.current.show("Задача выполнена",false,5000)
                    return
                }
                if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            })

        } catch (e) {

        } finally {
            setWork(false)
        }
    }

    return(
        <div className={styles.mainCont}>

            <MainFormTemplate title={"Список рассылки"} maxWidth={"1000px"}>
                <div className={"row"}>
                    <div className={styles.ldrCont}>
                        <div className={styles.ldrTitle}>Прогресс работы</div>
                        <div className={styles.ldr}>
                            <WaitLoader loading={work || ldrList} api={rsXlsFile} onlyLoading={true}>

                            </WaitLoader>
                        </div>
                        {work && <div className={styles.ldrTitle}>«{workName}»</div>}

                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        <div className={styles.inpCont}>
                            <Link to={`${baseUrl}/static/template/mass-template.xlsx`} className={styles.link}>Шаблон файла</Link>
                            <input type="file" className="form-control" accept={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
                                   onChange={(e)=>handleFile(e)}
                            >
                            </input>

                        </div>
                    </div>
                </div>

                <div className={"row"}>

                    <div className={styles.rowCont}>
                        <div className={styles.seCont}>
                            <SelectUnit
                                capt={"за период"}
                                inData={monthList}
                                ref={refMonth}
                                getVal={(e)=>setMonth(e[0])}
                            />

                        </div>

                        <InputItem
                            mode={"ie"}
                            title={"Год"}
                            val={year ? year : "-"}
                            ref={refYear}
                            skipFlow={true}

                            info={"Период - год"}
                            regExp={/^2[0-9]{3}$/ui}
                            onChange={(e)=>{
                                console.log("dd",e)
                                setYear(e)
                            }}

                        />

                    </div>
                </div>



                <div className={"row"}>
                    <ErrorLineItem ref={refState}></ErrorLineItem>
                </div>



                <div className={"row w-100"}>
                    <div className={["col-sm-12 d-flex align-self-center", styles.btGr].join(' ')}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    disabled={!fileSelected || work}
                                    onClick={()=>handleUpload()}
                            >Загрузить</button>


                        </div>
                    </div>
                </div>


            </MainFormTemplate>



            <TableItem
                data={simList}
                onPageCount={50}
                column={[
                    {
                        type:0,
                        title:"ctn",
                        fieldId: "ctn",
                        mode:"sf"
                    },
                    {
                        type:0,
                        title:"Группа",
                        fieldId: "group",
                        mode:"sf"
                    },
                    {
                        type:1,
                        title:"Сумма",
                        fieldId: "amount",
                        mode:"sf"
                    },

                ]}
            onReload={loadList}


            />
        </div>
    )
}